import { useQuery, useQueryClient } from "@tanstack/react-query";
import { useSyncExternalStore } from "react";

import { api, call } from "../api/client";
import { getToken, setToken, subscribe } from "./session";

export function useToken(): string | null {
  return useSyncExternalStore(subscribe, getToken);
}

export function useMe() {
  const token = useToken();
  return useQuery({
    queryKey: ["me"],
    queryFn: () => call(api.GET("/api/v1/me")),
    enabled: token !== null,
  });
}

export function useLogout() {
  const queryClient = useQueryClient();
  return async () => {
    try {
      // Ends the session on the server; offline, don't make the user wait for it.
      await Promise.race([api.POST("/api/v1/auth/logout"), new Promise((r) => setTimeout(r, 2000))]);
    } finally {
      // Clearing the token also drops the saved data cache (see main.tsx). Changes waiting
      // to sync are kept for this user's next sign-in on this device.
      setToken(null);
      queryClient.clear();
    }
  };
}
